import { Controller } from "@hotwired/stimulus";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// Counts a number up to its final value when it scrolls into view. The final
// value is the element's own server-rendered text (e.g. "99%"), parsed into a
// leading integer plus a suffix — so without JS, under reduced motion, or for a
// non-numeric value, the element just shows that text and nothing animates.
export default class extends Controller {
  static values = { duration: { type: Number, default: 1.2 } };

  connect() {
    // Skip Turbo's cached preview so the count only runs on the real page.
    if (document.documentElement.hasAttribute("data-turbo-preview")) {return;}

    const match = this.element.textContent.trim().match(/^(\d[\d\s,.]*)(\D*)$/);
    if (!match) {return;} // not a number (e.g. "PL + EN", "RODO") — leave as-is.

    const target = Number(match[1].replace(/[\s,.]/g, ""));
    const suffix = match[2];
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {return;}

    const counter = { value: 0 };
    this.element.textContent = `0${suffix}`;
    this.tween = gsap.to(counter, {
      value: target,
      duration: this.durationValue,
      ease: "power1.out",
      scrollTrigger: { trigger: this.element, start: "top 90%", once: true },
      onUpdate: () => {
        this.element.textContent = `${Math.round(counter.value)}${suffix}`;
      },
      // If torn down mid-count (Turbo navigation), snap to the final value.
      onInterrupt: () => {
        this.element.textContent = `${target}${suffix}`;
      },
    });
  }

  disconnect() {
    this.tween?.scrollTrigger?.kill();
    this.tween?.kill();
    this.tween = null;
  }
}
